<template>
  <div :class="`m-portal m-portal-${routeType}-page`">
    <portal-nav-top :activeIndex="2"></portal-nav-top>
    <div id="ljh-information">
      <div class="container-fluid" style="width:1100px;">
        <el-row :gutter="20">
          <el-col :span="6" class="left-menu-wrap">
            <portal-new-nav></portal-new-nav>
          </el-col>
          <el-col :span="18" class="content-page-wrap">
            <div class="content-page">
              <div class="navigation">
                <span>首页</span>
                <span>&nbsp;>&nbsp;</span>
                <span>朱子文化</span>
                <span>&nbsp;>&nbsp;</span>
                <span>{{title[$route.params._field]}}</span>
              </div>
              <div class="article">
                <bs-page :filter="filter" :meta="meta" ref="refId" content-class>
                  <template slot="data" slot-scope="slot">
                    <div class="news">
                      <ul class="newsUI">
                        <li v-for="item in slot.data" :key="item.newId">
                          <a @click="handleDetail(item)">{{item.title}}</a>
                          <span class="time" v-text="item.pushDate||item.modifyDate"></span>
                        </li>
                      </ul>
                    </div>
                  </template>
                  <template slot="empty">
                    <div>
                      <img src="../../assets/portal/zwsj.png" style="width:100%;height:300px" />
                    </div>
                  </template>
                  <template slot="paging" slot-scope="slot">
                    <el-pagination
                      layout="prev, pager, next"
                      v-if="slot.data.totalCount>20"
                      background
                      style="float:clear; clear:both;margin:0 auto;text-align: center"
                      @size-change="pageSizeChange"
                      @current-change="pageIndexChange"
                      :current-page="filter.pageIndex"
                      :page-size="filter.pageSize"
                      :total="slot.data.totalCount"
                    ></el-pagination>
                  </template>
                </bs-page>
              </div>
            </div>
          </el-col>
        </el-row>
      </div>
    </div>
    <div>
      <portal-footer></portal-footer>
    </div>
  </div>
</template>
<script>
require("../../styles/portal/information.scss");
export default {
  data() {
    return {
      title: {
        xwzx: "活动新闻",
        hdgg: "公告通知",
        llyj: "理论研究",
        dwjl: "对外交流"
      },
      routeType: "new",
      meta: {
        module: this.$route.params._module,
        field: this.$route.params._field
      },
      filter: {
        pageIndex: 1,
        pageSize: 20
      },
      api: null
    };
  },
  mounted() {},
  props: {
    routeWatch: {
      type: Boolean,
      default: true
    }
  },
  components: {
    BsPage: () => import("../../components/bs-page"),
    PortalNavTop: () => import("./portal-nav-top"),
    PortalNewNav: () => import("./portal-new-nav"),
    PortalFooter: () => import("./portal-footer")
  },
  methods: {
    handleDetail(item) {
      let _module = this.$route.params._module;
      let _field = this.$route.params._field;
      this.$router.push({
        path: `/portal/new/detail/${_module}/${_field}_detail/${item.newId}`
      });
    },
    pageSizeChange(val) {
      let that = this;
      that.filter.pageSize = val;
      this.$refs["refId"].loadData();
    },
    pageIndexChange(val) {
      let that = this;
      that.filter.pageIndex = val;
      this.$refs["refId"].loadData();
    }
  },
  created() {
    this.$menuFn.setTitle(this.title[this.$route.params._field]+ "-朱子文化·综合信息服务平台");
  },
  watch: {
    $route: function(to, from) {
      if (to.name === "portal-new-page") {
        this.$menuFn.setTitle(this.title[this.$route.params._field]+ "-朱子文化·综合信息服务平台");
      }
      let contains = this.$loadRouteData(
        from,
        to,
        this.routeType,
        "page",
        "portal",
        false
      );
      if (this.routeWatch && contains) {
        this.$refs["refId"].clearData();
        this.meta.module = this.$route.params._module;
        this.meta.field = this.$route.params._field;
        this.$refs["refId"].loadData();
      }
    }
  }
};
</script>
<style lange="sass" scoped>
</style>